export default "__VITE_ASSET__DUE2Izco__"